import { z } from "zod";
import { Instant, Note } from "./common.js";
import { Context } from "./identity.js";
import { Id } from "./ids.js";

/** Append-only audit event (ADR-10). Never updated, never deleted. Carries no PIN, OTP or token. */
export const AuditEvent = z.object({
  id: Id,
  at: Instant,
  actor: z.object({
    personId: Id.nullable(),
    deviceId: Id.nullable(),
    context: Context.nullable(),
  }),
  /** `module.verb`, e.g. `identity.role-archived`. */
  action: z.string().regex(/^[a-z][a-z0-9-]*\.[a-z][a-z0-9-]*$/),
  /** Usually a UUIDv7 entity id; name-based ids (UUIDv5, `nameId`) for things like modules. */
  entity: z.object({ type: z.string().min(1).max(64), id: z.uuid() }),
  before: z.json().nullable(),
  after: z.json().nullable(),
  reason: Note.nullable(),
  viaSupport: z.boolean().default(false),
});
export type AuditEvent = z.infer<typeof AuditEvent>;
